import { z } from "zod";
import { RichTextSchema } from "../../fragments/RichText";
import { BladeCommonSchema } from "../common";
import { ActionSchema } from "../../fragments/Actions";
import { MediaSchema } from "../../fragments/Media";
const RichTextBladeSideMediaPositionEnum = z.enum(["before", "after"]);
export const RichTextBladeSideMediaSchema = z.object({
    media: MediaSchema,
    position: RichTextBladeSideMediaPositionEnum,
    action: ActionSchema.optional(),
});
const RichTextBladeTypeValues = ["articleRichText", "landingRichText", "patchNotesRichText"];
export const RichTextBladeTypesSchema = z.enum(RichTextBladeTypeValues);
export const RichTextBladeTypes = RichTextBladeTypesSchema.enum;
export const RichTextBladeSchema = BladeCommonSchema.extend({
    richText: RichTextSchema,
    sideMedia: RichTextBladeSideMediaSchema.optional(),
});
export const RichTextBladesContractSchema = RichTextBladeSchema.extend({
    type: RichTextBladeTypesSchema,
});
export const ArticleRichTextBladeContractSchema = RichTextBladesContractSchema.extend({
    type: z.literal(RichTextBladeTypes.articleRichText),
});
export const LandingRichTextBladeContractSchema = RichTextBladesContractSchema.extend({
    type: z.literal(RichTextBladeTypes.landingRichText),
});
export const PatchNotesRichTextBladeContractSchema = RichTextBladesContractSchema.extend({
    type: z.literal(RichTextBladeTypes.patchNotesRichText),
});
//# sourceMappingURL=index.js.map